import {
	getDate,
	getMonth,
	getYear,
	isAfter,
	isValid,
	parse,
	startOfDay,
	subYears,
} from 'date-fns';
import { z } from 'zod';

import { basicResponseSchema } from '../../get/schemas/get-common.schema';

export const postFriendFamilyNewRequestSchema = z
	.object({
		birthYear: z
			.string({ required_error: 'register.year_required_error' })
			.transform((val) => parseInt(val)),
		birthMonth: z
			.string({ required_error: 'register.month_required_error' })
			.transform((val) => parseInt(val)),
		birthDay: z
			.string({ required_error: 'register.day_required_error' })
			.transform((val) => parseInt(val)),
		firstName: z.string().nonempty('validation.firstname_empty'),
		lastName: z.string().nonempty('validation.lastname_empty'),
		fullBirthDate: z.string().optional(),
	})
	.refine(
		(data) => {
			const { birthYear, birthMonth, birthDay } = data;
			const referenceDate = startOfDay(new Date());
			const birthDate = parse(
				`${birthYear}-${birthMonth}-${birthDay}`,
				'yyyy-M-d',
				referenceDate
			);

			const hasMatchingComponents =
				isValid(birthDate) &&
				getYear(birthDate) === birthYear &&
				getMonth(birthDate) + 1 === birthMonth &&
				getDate(birthDate) === birthDay;

			if (!hasMatchingComponents) {
				return false;
			}

			const today = startOfDay(new Date());
			const birthDayStart = startOfDay(birthDate);

			if (isAfter(birthDayStart, today)) {
				return false;
			}

			const youngestAllowedBirthday = startOfDay(subYears(today, 13));
			return isAfter(birthDayStart, youngestAllowedBirthday);
		},
		{
			message: 'validation.under_age_13',
			path: ['fullBirthDate'],
		}
	);

export const postFriendFamilyNewResponseSchema = basicResponseSchema.extend({
	user: z.object({
		userId: z.string(),
		ticketingId: z.string(),
		firstName: z.string(),
		lastName: z.string(),
		birthYear: z.number(),
		birthMonth: z.number(),
		birthDay: z.number(),
	}),
});
